module.exports = __webpack_public_path__ + "img/homeImg1.8b06728d.png";